var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "justify-center", attrs: { id: "documenten" } },
    [
      _c("ehr-navigation", { attrs: { "active-item": "documenten" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "section-card",
            {
              attrs: { "card-title": "Documenten", "card-icon": "file-alt" },
              scopedSlots: _vm._u([
                {
                  key: "extraHeaderContent",
                  fn: function() {
                    return [
                      _vm.amountUploadsNeeded > 0
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "badge badge-primary ml-2 mt-2 float-right"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.amountUploadsNeeded) +
                                  " uploads vereist\n        "
                              )
                            ]
                          )
                        : _c(
                            "span",
                            {
                              staticClass:
                                "badge badge-success ml-2 mt-2 float-right"
                            },
                            [
                              _vm._v(
                                "\n          Geen uploads vereist\n        "
                              )
                            ]
                          )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "container d-flex flex-row justify-content-center mb-3"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "btn-group btn-group-toggle float-right",
                      attrs: { "data-toggle": "buttons" }
                    },
                    [
                      _c("label", { staticClass: "btn btn-secondary active" }, [
                        _c("input", {
                          attrs: {
                            type: "radio",
                            name: "options",
                            id: "option1",
                            autocomplete: "off",
                            checked: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.showAllDocuments = true
                            }
                          }
                        }),
                        _vm._v("\n            Alle documenten\n          ")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "btn btn-secondary" }, [
                        _c("input", {
                          attrs: {
                            type: "radio",
                            name: "options",
                            id: "option2",
                            autocomplete: "off"
                          },
                          on: {
                            click: function($event) {
                              _vm.showAllDocuments = false
                            }
                          }
                        }),
                        _vm._v("\n            Upload vereist\n          ")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "transition-group",
                    {
                      staticClass: "row text-center justify-content-center",
                      attrs: { name: "list", tag: "div" }
                    },
                    _vm._l(_vm.documentsToShow, function(document, index) {
                      return _c("document-block", {
                        key: "document-block-" + index,
                        staticClass: "list-item",
                        attrs: {
                          "document-title": document.documentTitle,
                          description: document.description,
                          status: document.status
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }